export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11787.d6dfb7b1.jpg";